import { render, staticRenderFns } from "./voucherRows.vue?vue&type=template&id=8995b6e2&scoped=true"
import script from "./voucherRows.vue?vue&type=script&lang=js"
export * from "./voucherRows.vue?vue&type=script&lang=js"
import style0 from "./voucherRows.vue?vue&type=style&index=0&id=8995b6e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8995b6e2",
  null
  
)

export default component.exports